"use strict";
exports.__esModule = true;
exports.RENT_AMOUNT_LIMITS = void 0;
exports.RENT_AMOUNT_LIMITS = {
    validatorConfig: {
        minRentAmount: 300,
        maxRentAmount: 10000
    },
    textContent: 'Flex only supports rent amounts between $300 and $10,000'
};
